import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { observer } from 'mobx-react';
import isNil from 'lodash/isNil';
import FancySelect from '@/common/components/inputs/FancySelect/FancySelect';
import { getDataAccessById, getDataAccessIcon } from '@/security/constants/dataAccess';
import { ProductDataAccess, ProjectDataAccess } from '@/security/types/DataAccess';
import { fromRecursiveOptionValue, toRecursiveOptionValue } from './RecursiveSelect.utils';
function RecursiveSelect(props) {
    const { isRecursive, dataAccess, disabled, onChange } = props;
    const options = useMemo(() => {
        if (isNil(dataAccess)) {
            return [];
        }
        const productAccessValue = dataAccess === ProjectDataAccess.ShowAllData
            ? ProductDataAccess.ShowAllData
            : ProductDataAccess.HideAllDesignData;
        return [
            {
                value: 1,
                label: getDataAccessById(productAccessValue, 'product').title,
                icon: getDataAccessIcon(productAccessValue, 'product'),
            },
            {
                value: 0,
                label: 'Leave unchanged',
            },
        ];
    }, [dataAccess]);
    return (_jsx(FancySelect, { disabled: disabled, onChange: (option) => onChange(fromRecursiveOptionValue(option?.[0]?.value)), noOptionsMessage: isNil(dataAccess) ? 'Select Project Data Access first' : '', options: options, placeholder: "", value: toRecursiveOptionValue(dataAccess, isRecursive) }));
}
export default observer(RecursiveSelect);
